import { useRunner } from "@/queries/runner-queries";
import { RunnerProvider } from "gitpod-next-api/gitpod/v1/runner_configuration_pb";
import { type FC } from "react";
import { useParams } from "react-router-dom";
import { InstallLinuxRunnerPage } from "./InstallLinuxRunnerPage";
import { InstallAWSRunnerPage } from "./InstallAWSRunnerPage";

export const InstallRunnerPage: FC = () => {
    const params = useParams();
    const { data: runner } = useRunner(params.runnerId);

    const isLoading = !runner;
    if (isLoading) {
        return <></>;
    }

    switch (runner.provider) {
        case RunnerProvider.LINUX_HOST:
            return <InstallLinuxRunnerPage />;
        case RunnerProvider.AWS_EC2:
            return <InstallAWSRunnerPage />;
        default:
            return <></>;
    }
};
